import { render, staticRenderFns } from "./creatRoster.vue?vue&type=template&id=cdea8894&scoped=true&"
import script from "./creatRoster.vue?vue&type=script&lang=ts&"
export * from "./creatRoster.vue?vue&type=script&lang=ts&"
import style0 from "./creatRoster.vue?vue&type=style&index=0&id=cdea8894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdea8894",
  null
  
)

export default component.exports